window.onload = function(event) {

  if( document.querySelector('.testimonials blockquote') ) {
    let i = 0;
    document.querySelectorAll('.testimonials blockquote').forEach((ele) => {
      i++;
      const x = 200 + (i*50);
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateY(" + x + "px)",
            "translateY(0)"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });

    i = 0;
    document.querySelectorAll('.key_message:nth-child(odd)').forEach((ele) => {
      const x = 200 + (i*50);
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateY(" + x + "px) translateX(-100px)",
            "translateY(0) translateX(0)"
          ],
          opacity: [
            "0.5",
            "1"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });

    i = 0;
    document.querySelectorAll('.key_message:nth-child(even)').forEach((ele) => {
      const x = 200 + (i*50);
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateY(" + x + "px) translateX(100px)",
            "translateY(0) translateX(0)"
          ],
          opacity: [
            "0.5",
            "1"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });

    document.querySelectorAll('.programmes figure[data-active] img').forEach((ele) => {
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.8))
        ]
      });
      ele.animate(
        {
          transform: [
            "translateX(-10vw) rotate(5deg)",
            "translateX(0) rotate(0)"
          ],
          boxShadow: [
            "0 0 0 10px white, 2px 2px 25px 5px rgba(0,0,0,0.2)",
            "0 0 0 10px white, 2px 2px 25px 5px transparent"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });

    document.querySelectorAll('.activities li').forEach((ele) => {
      const ele_offset_top = ele.getBoundingClientRect().top + window.scrollY;
      const ele_height = ele.offsetHeight;
      const timeline = new ScrollTimeline({
        scrollOffsets: [
          CSS.px(ele_offset_top - window.innerHeight),
          CSS.px(ele_offset_top - (window.innerHeight*0.5))
        ]
      });
      ele.animate(
        {
          transform: [
            "perspective(1000px) translateY(100vh) scale(3) rotateX(200deg)",
            "perspective(1000px) translateY(0) scale(1) rotateX(0)"
          ],
          opacity: [
            "0.2",
            "1"
          ]
        },
        {
          duration: 1,
          timeline: timeline
        }
      );
    });
  }

};
